<script>
    import { fade } from 'svelte/transition';
</script>

<div class="root absolute left-0 top-0 z-[2] h-full w-full overflow-hidden desktop:z-auto" transition:fade />

<style>
    .root {
        backdrop-filter: blur(5px);
    }
</style>
